import { TFunction } from '@gem/modules/i18n';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatAdminsAddedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  return {
    html: t('group_chat_user_was_promoted_to_admin', {
      0: `<span class="system-message-title">${presenter.firstUserDisplayedName}</span>`,
      interpolation: { escapeValue: false },
    }),
    sourceText: t('group_chat_user_was_promoted_to_admin'),
    params: {
      '{0}': { text: presenter.firstUserDisplayedName, userId: presenter.firstUserId },
    },
  };
};
